import { AxiosHeaders, AxiosRequestConfig } from 'axios';
import { HttpResponse } from 'models';
import {
  LoginFormRequestModel,
  LoginFormResponseModel,
  ChangePasswordFormRequestModel,
  ForgotPasswordFormRequestModel,
  ResetPasswordFormRequestModel,
  GoogleLoginRequestModel,
  AppleLoginRequestModel,
  TwitterLoginRequestModel,
  ChangeNameFormRequestModel,
} from 'models/auth';
import axiosClient, { handleRequest } from './axiosClient';
import { getLocalStorage } from 'utils/sessionStorage';

const authApi = {
  login: (body: LoginFormRequestModel): Promise<HttpResponse<LoginFormResponseModel>> => {
    const url = `/terabet/api/login`;
    return handleRequest(axiosClient.post(url, body));
  },
  logout: (headers?: AxiosRequestConfig<AxiosHeaders>) => {
    const url = `/terabet/api/logout`;
    return handleRequest(axiosClient.post(url, null, headers));
  },
  changePassword: (body: ChangePasswordFormRequestModel) => {
    const url = `/terabet/api/change-password`;
    return handleRequest(
      axiosClient.post(url, body, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  changeName: (body: ChangeNameFormRequestModel)=> {
    const url = `/terabet/api/change-name`;
    return handleRequest(
      axiosClient.post(url, body, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },

  forgotPassword: (body: ForgotPasswordFormRequestModel) => {
    const url = `/terabet/api/forgot-password`;
    return handleRequest(axiosClient.post(url, body));
  },
  resetPassword: (body: ResetPasswordFormRequestModel) => {
    const url = `/terabet/api/reset-password`;
    return handleRequest(axiosClient.post(url, body));
  },
  googleLogin: (body: GoogleLoginRequestModel): Promise<HttpResponse<LoginFormResponseModel>> => {
    const url = `/terabet/api/sso-login`;
    return handleRequest(axiosClient.post(url, body));
  },
  appleLogin: (body: AppleLoginRequestModel): Promise<HttpResponse<LoginFormResponseModel>> => {
    const url = `/terabet/api/apple-login`;
    return handleRequest(axiosClient.post(url, body));
  },
  twitterLogin: (body: TwitterLoginRequestModel): Promise<HttpResponse<LoginFormResponseModel>> => {
    const url = `/terabet/api/twitter-login`;
    return handleRequest(axiosClient.post(url, body));
  },
  activeAccount: (token: string) => {
    const url = `/terabet/api/active-user/${token}`;
    return handleRequest(axiosClient.post(url));
  },
  resendActiveLink: (body: ForgotPasswordFormRequestModel) => {
    const url = `/terabet/api/active-user/resend-link`;
    return handleRequest(axiosClient.post(url, body));
  },
};

export default authApi;
